import { Component } from '@angular/core';

@Component({
  selector: 'app-dustdevils',
  standalone: true,
  imports: [],
  templateUrl: './dustdevils.component.html',
  styleUrl: './dustdevils.component.scss'
})
export class DustdevilsComponent {

}
